import React, { useState } from 'react';
import { Fab, Zoom } from '@mui/material';
import Icon from '../ui/Icon';
import { useGameContext } from '../../contexts/GameContext';
import { useSessionContext } from '../../contexts/SessionContext';
import GameSettingsModal from '../GameSettingsModal/GameSettingsModal';

const SettingsButton: React.FC = () => {
  const { user_id } = useSessionContext();
  const { code, finished, adminId, settings } = useGameContext();

  const [open, setOpen] = useState(false);

  if (!code) {
    return null;
  }

  return (
    <>
      {!finished && (
        <Zoom
          in={!open}
          timeout={100}
          unmountOnExit
          style={{
            transitionDelay: "100ms",
            position: 'fixed',
            top: 12,
            right: 12,
            zIndex: 10,
          }}
        >
          <Fab
            color="default"
            aria-label="Configurações"
            onClick={() => setOpen(true)}
            size="medium"
          >
            <Icon name="settings" size={20} />
          </Fab>
        </Zoom>
      )}

      <GameSettingsModal
        visible={open}
        code={code}
        settings={settings}
        onClose={() => setOpen(false)}
        isAdmin={adminId === user_id}
      />
    </>
  );
}

export default SettingsButton;